module.exports = __webpack_public_path__ + "static/media/dropdown_icon.81c73e76.svg";